export const isLearningUpdateCommand = (request: string): boolean => {
    const normalized = request.trim().toLowerCase();

    return (
        normalized === '/ul' ||
        normalized.startsWith('/ul ') ||
        normalized === '/updatelearnings' ||
        normalized.startsWith('/updatelearnings ') ||
        normalized === '/uo' ||
        normalized.startsWith('/uo ')
    );
};
